import React from "react";
 
import background from '../../image/msg2.svg'
import qrcode2  from '../../image/qrcode4.svg'
import eee  from '../../image/eee.png'
  
import footer  from '../../image/footer.svg'

import Lottie from 'react-lottie';
import animationData1 from '../../lotties/send';
import animationData2 from '../../lotties/error';

import axios from 'axios';
import { FaFacebookSquare, FaGithubSquare , FaLinkedin, FaQuora} from 'react-icons/fa';
import 'react-responsive-modal/styles.css';
import { Modal } from 'react-responsive-modal';


export default class Footer extends React.Component {

constructor(){
  super()
  this.state={
    name:"",
    inemail:"",
    inmessage:"",
    open:false,
    error:false,
  }
}
 
onOpenModal = () => this.setState({open:true});

onCloseModal = () => this.setState({open:false});

namevalue=(event)=>{
var val=event.target.value;
this.setState({name:val})
} 

emailvalue=(e)=>{
var val=e.target.value;
this.setState({inemail:val})
} 

inputmessage=(e)=>{
var val=e.target.value;
this.setState({inmessage:val})
}  


render() {


  const sucessanimation = {
    loop: true,
    autoplay: true,
    animationData: animationData1,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice"
    }
  };

  const erroranimation = {
    loop: true,
    autoplay: true,
    animationData: animationData2,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice"
    }
  };


const formdata= {
      name:this.state.name,
      email: this.state.inemail,
      message: this.state.inmessage
 
    }
  
const erasedata=()=>{
this.setState({name:""})
this.setState({inemail:""})
this.setState({inmessage:""})
}

const clear_input=()=>{
  formdata.name=""
  formdata.email=""
  formdata.message=""
  document.getElementById("name").value=""
  document.getElementById("email").value=""
  document.getElementById("message").value=""
}

const openModel=()=>this.onOpenModal();
const errormsg=()=>this.setState({error:true});

 

const submit=()=>{

  // i chack for user not press empty value
  if (this.state.inemail===""||this.state.name===""||this.state.inmessage===""){
    var v=document.getElementById("alertmessage")
    v.style.display="block";
    var x = document.getElementById("myStrong");
    x.innerText="plase complete required field"
 
  }else{
    const reg = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/;
      if( reg.test(this.state.inemail) === false){
      var alertmessage=document.getElementById("alertmessage")
      alertmessage.style.display="block";
      var myStrong = document.getElementById("myStrong");
      myStrong.innerText="invalid email id"
      document.getElementById("email").value="" 
    }else{
      var loader=document.getElementById("loader")
      loader.style.display="block"

      axios({
          method: 'post',
          url:'https://ebrahimdev.pythonanywhere.com/api/v1/contact_me/',
          data: formdata
          }).then(response =>  { 
            openModel()
            erasedata()
            clear_input()
            loader.style.display="None" 
        }).catch(function (error) {
          // handle error       
          loader.style.display="None" 
          openModel()
          errormsg()
          erasedata()
          clear_input()
        })
      //end axios
    }
  }
}


 
const masval=()=>{
  document.getElementById("alertmessage").style.display="none"
}



return (


 <footer className="page-footer " style={{ backgroundImage: `url(${footer})`,  backgroundSize:'cover'}} >
     
     <Modal  classNames={{ modal: 'customModal',}} open={this.state.open} onClose={this.onCloseModal} center>
        {!this.state.error?
        <>
         <h3 style={{textAlign:'center', marginTop:'25px'}}>Thanks for contact us  👍   {this.state.name} Your message will forward to ebrahim16sust@gmail.com</h3>
         <Lottie  options={sucessanimation}  height={'50%'} width={'60%'}/> 
        </>
        :
        <>
         <h3 style={{textAlign:'center', marginTop:'25px'}}>Your email is not sending becuause  ⚠️ external Rest-Api request surver not working..please contact 📧ebrahim16sust@gmail.com  </h3>
         <Lottie  options={erroranimation}  height={'100%'} width={'100%'}/> 
        </>}   
      </Modal>
    
    <div className="container-fluid text-center text-md-left">
          {/* Grid row */}
      <div className="row">
         <div className="col-md-4 ">
              <br />
              <h2 style={{textAlign:'center', fontWeight:'bold', marginTop:'115px'}}>Get in touch</h2> 


              <div style={{ marginTop:'20px',marginBottom:'20px', display:'flex', justifyContent:'center'}}>
                <a style={{marginLeft: '3%'}} href="https://www.facebook.com/ebrahim1bd" className="fb-ic">
                  <FaFacebookSquare style={{height:'48px', width:'48px', color:'blue'}}/>    
                </a>
                {/* Twitter */}
                <a style={{marginLeft: '7%'}} href="https://github.com/ebrahimbd">
                  <FaGithubSquare style={{height:'48px', width:'48px', color:'black'}}/> 
                </a>
                {/*Linkedin */}
                <a style={{marginLeft: '7%'}} href="https://www.linkedin.com/in/ebrahimbd/"class=" li-ic">
                  <FaLinkedin style={{height:'48px', width:'48px',color:'blue'}}/>    
                </a>
                <a style={{marginLeft: '7%'}} href="https://www.quora.com/profile/Ebrahim-Mohammad-Saleh/">
                  <FaQuora style={{height:'48px', width:'48px',color:'red'}}/>     
                </a>
              </div>
    
              <br />
          </div>
           
          <div className="col-md-5"  style={{ backgroundImage: `url(${background})`,  backgroundSize:'cover'}}>  
              <div style={{}} id="main" />

                <h5 style={{height: '55px', fontSize: '30px'}} > </h5>
                <div class="alert alert-danger alert-dismissible fade show" id="alertmessage" role="alert" style={{width:'75%', display:'none',textAlign:'center'}}>
                  <strong id="myStrong"></strong>  
                  <button type="button" onClick={masval} id="closealert">
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>

                  <input type="text"  onChange={this.namevalue} id="name"  className="form-control input" name="name" placeholder="name" maxLength={60} style={{marginBottom: '10px', width: '50%', fontSize: '16px'}} required />
                  <input type="email" onChange={this.emailvalue} id="email" className="form-control input" name="email" style={{marginBottom: '10px', width: '50%', fontSize: '16px'}} placeholder="Email" required />
                  <textarea name="message" onChange={this.inputmessage} id="message" type="text" className="form-control input" placeholder="Message" style={{resize: 'none', marginBottom: '10px', width: '50%', fontSize: '16px'}} maxLength={200} required  />
                   
                  <div class="loader" id="loader"></div>

                  <button value="submit" onClick={submit}   className="btn btn-success" style={{fontWeight: 'bold', fontSize: '16px'}}> Send Message</button>
                               
         </div>      

          <div id="con2" className="col-md-3">
  
      <img alt={""} style={{height: '250px', width: '100%', backgroundSize:'cover' ,marginTop:'50px' }} src={qrcode2} />
          
       </div>


      </div>
    </div>
        

        <div className="rgba-black-light text-center  py-1" style={{backgroundColor: 'rgba(0,0,0,0.3)', fontSize: '20px'}}> <u><a style={{color:' #f8f9fa'}} href="https://www.linkedin.com/in/ebrahimbd/">© 2021 Developed by <img src={eee} height={21} alt={""}/> Mohammad Saleh</a></u>
          <p id="saleh" />
        </div>
        {/* Copyright */}
  </footer>

    )
  }
}